import { ProcessTypes, RowTypes } from "../../../../../api.app/controllers/constants";

const utils = (context) => {};

const main = (context) => {
  const { dispatch, current, rootState } = context;
  return {
    addShape(index, count) {
      const firstActivityIndex = current.design.rows.findIndex((item) => item.type === RowTypes.Activity);
      const rowIds = current.design.rows.slice(index, index + count).map((item) => item.id);
      rowIds.forEach(async (rowId, rowIndex) => {
        await dispatch(
          "customFlow/addShape",
          { id: rowId, atIndex: index + rowIndex - firstActivityIndex },
          { root: true }
        );
      });
      return async () => {
        await dispatch("customFlow/deleteShape", rowIds, { root: true });
      };
    },
    moveShape(rowSourceIndex, rowTargetIndex, count) {
      const firstShape = rootState.customFlow.shapes[0];
      if (!firstShape || current.type === ProcessTypes.Grid) return () => {};

      const [, rowId] = firstShape.split("_");
      let firstShapeRowIndex = current.design.rowMap[rowId].index;

      dispatch(
        "customFlow/repositionShape",
        {
          sourceIndex: rowSourceIndex - firstShapeRowIndex,
          targetIndex: rowTargetIndex - firstShapeRowIndex,
          count,
        },
        { root: true }
      );
      return () => {
        this.moveShape(rowTargetIndex, rowSourceIndex, count);
      };
    },
  };
};
export default (context) => {
  return {
    main: main(context),
    utils: utils(context),
  };
};
